import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BankingArchive from "../../../Components/Archive/Banking/BankingArchive";
import styles from "./Page_Archive.module.css";
import ArchiveHeader from "./ArchiveHeader";
import BuySellArchive from "../../../Components/Archive/BuySell/BuySellArchive";
import RAArchive from "../../../Components/Archive/RA/RAArchive";
import RFQArchive from "../../../Components/Archive/RFQ/RFQ";

const Page_Archive = () => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  );
  const mapingData = useSelector((s) => s?.platformSlice?.userPaymentConfigs);
  const state = useSelector(
    (store) => store?.persistedReducer?.company?.stateLabel,
  );

  const isBanking = role === "BANKING";
  const [type, setType] = useState(isBanking ? "Banking" : "Bilateral");
  const [status, setStatus] = useState("Closed");

  function onBack() {
    window.history.back();
  }

  return (
    <div className={styles.archiveWrapper}>
      <ArchiveHeader
        onBack={onBack}
        initialType={type}
        initialStatus={status}
        onTypeChange={setType}
        onStatusChange={setStatus}
        types={
          isBanking
            ? ["Banking"]
            : mapingData?.some((ele) => ele?.productName === "TRADE_CONNECT")
              ? [
                  "Bilateral",
                  "TradeConnect",
                  "RFP (INTERSTATE)",
                  "Reverse Auction",
                ]
              : [
                  "Bilateral",
                  "RFP (INTRASTATE)",
                  "RFP (INTERSTATE)",
                  "Reverse Auction",
                ]
        }
      />
      <div
        style={{
          padding: "15px",
        }}
      >
        {role === "BANKING" ? (
          <BankingArchive type={type} status={status} />
        ) : type === "Bilateral" ? (
          <BuySellArchive type={type} status={status} />
        ) : type === "TradeConnect" ? (
          <RFQArchive type={type} status={status} auctionType={"CLOSED"} />
        ) : type === "RFP (INTRASTATE)" ? (
          <RFQArchive type={type} status={status} auctionType={"OPEN"} />
        ) : type === "RFP (INTERSTATE)" ? (
          <RFQArchive type={type} status={status} auctionType={"CLOSED"} />
        ) : type === "Reverse Auction" ? (
          <RAArchive type={type} status={status} />
        ) : null}
      </div>
    </div>
  );
};

export default Page_Archive;
